import React from "react";
import { Link } from "react-router-dom";
import FadeIn from "../components/FadeIn";
import { IMAGES, EXPERIENCE_GROUPS } from "../lib/content";

const Experiences = () => {
  return (
    <main className="pt-28 md:pt-36" data-testid="experiences-page">
      <section className="py-20 md:py-28 border-b border-white/5">
        <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <FadeIn>
              <div className="overline">Experiences</div>
              <h1 className="mt-5 font-serif text-5xl md:text-7xl text-bone tracking-tight leading-[1.02]">
                Elevated,<br /><span className="italic text-gold">without being loud.</span>
              </h1>
            </FadeIn>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <FadeIn delay={140}>
              <p className="text-bone/65 font-light text-lg leading-relaxed max-w-lg">
                Every experience below is an example — a starting point. The final program is written around you.
              </p>
            </FadeIn>
          </div>
        </div>
      </section>

      {EXPERIENCE_GROUPS.map((group, i) => {
        const reverse = i % 2 === 1;
        return (
          <section key={group.slug} className="py-20 md:py-28 border-b border-white/5" data-testid={`experience-group-${group.slug}`}>
            <div className="container-editorial grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-start">
              <FadeIn className={`md:col-span-6 ${reverse ? "md:order-2" : ""} md:sticky md:top-32`}>
                <div className="relative overflow-hidden h-[360px] md:h-[520px] group">
                  <img
                    src={IMAGES.experiences[group.image]}
                    alt={group.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-[1.04]"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
                  <div className="absolute bottom-8 left-8 overline">{String(i + 1).padStart(2, "0")} / {EXPERIENCE_GROUPS.length.toString().padStart(2, "0")}</div>
                </div>
              </FadeIn>

              <FadeIn delay={120} className={`md:col-span-6 ${reverse ? "md:order-1" : ""}`}>
                <div className="overline mb-5">Category</div>
                <h2 className="font-serif text-5xl md:text-6xl text-bone tracking-tight leading-[1.05]">{group.title}</h2>
                <div className="mt-6 rule" />
                <ul className="mt-10 divide-y divide-white/10 border-y border-white/10">
                  {group.items.map((item, j) => (
                    <li key={j} className="flex items-baseline gap-6 py-6" data-testid={`experience-${group.slug}-item-${j}`}>
                      <span className="font-serif text-gold text-base tabular-nums w-10">{String(j + 1).padStart(2, "0")}</span>
                      <span className="font-serif text-xl md:text-2xl text-bone/90 tracking-tight">{item}</span>
                    </li>
                  ))}
                </ul>
              </FadeIn>
            </div>
          </section>
        );
      })}

      <section className="py-32 md:py-44">
        <div className="container-editorial text-center max-w-3xl mx-auto">
          <FadeIn>
            <h2 className="font-serif text-4xl md:text-6xl text-bone tracking-tight leading-[1.05]">
              Not everything is listed.<br />
              <span className="italic text-gold">Each journey is designed individually.</span>
            </h2>
          </FadeIn>
          <FadeIn delay={180}>
            <div className="mt-12">
              <Link
                to="/plan"
                className="inline-flex items-center gap-4 bg-gold text-ink px-10 py-5 text-[12px] tracking-[0.28em] uppercase font-medium hover:bg-gold-light transition-colors duration-500"
                data-testid="experiences-cta"
              >
                Plan Your Journey
                <span className="w-8 h-px bg-ink/60" />
              </Link>
            </div>
          </FadeIn>
        </div>
      </section>
    </main>
  );
};

export default Experiences;
